import {CartApi, CustomCartApi} from '@/api/cart';
import {mapActions, mapState} from 'vuex';

/**
 * Update quantity in mini cart container.
 * @param quantity
 */
const updateMiniCartCount = (quantity) => {
  const miniCart = document.querySelectorAll('[id="miniCartItemCount"]');
  if (!miniCart || !miniCart.length) {
    return;
  }

  miniCart.forEach((cartContainer) => {
    cartContainer.innerHTML = quantity;
    cartContainer.classList.remove('hide');
  });
};

const AddToCart = {
  computed: {
    ...mapState('backend', ['b2b']),
  },

  methods: {
    ...mapActions('miniCart', ['fetchMiniCart']),
    displayRichError(data) {
      const message = data.message.replace(/<[^>]+>/g, '');
      window.vm.toast({
        type: 'alert',
        duration: 5000,
        showClose: true,
        message: message,
        action: data.action,
        dangerouslyUseHTMLString: true,
      });
    },

    displaySimpleError(message) {
      window.vm.toast({
        duration: 5000,
        type: 'alert',
        message,
      });
    },

    displaySpectrumWarning(data) {
      window.vm.toast({
        duration: 5000,
        type: 'warning',
        message: data.message,
        dangerouslyUseHTMLString: true,
      });
    },

    addToCart(code, quantity) {
      if (!quantity || !code) {
        return;
      }

      this.addToCartButtonCaption = this.bp('addingToCart');
      this.isAddingToCart = true;
      this.cartSuccessMessage = '';

      CartApi.add({quantity, code})
        .then((data) => {
          if (!data.quantityAdded) {
            // Failed to add product to cart. Display message.
            if (data.message) {
              this.displayRichError(data);
            }
          } else {
            // Product successfully added.
            this.cartSuccessMessage = this.bp('addedToCart').replace('{0}', data.quantityAdded);
            updateMiniCartCount(data.quantity);

            if (this.b2b) {
              this.fetchMiniCart();
            }
          }
        })
        .catch(() => {
          this.displaySimpleError(this.bp('cartErrorGeneral'));
        })
        .finally(() => {
          this.isAddingToCart = false;
          this.addToCartButtonCaption = this.bp('addToBasket');
        });
    },
    addToCartCustom(payload) {
      if (!payload) {
        return;
      }

      this.addToCartButtonCaption = this.bp('addingToCart');
      this.isAddingToCart = true;
      this.cartSuccessMessage = '';

      CustomCartApi.add(payload)
        .then((data) => {
          if (!data.quantityAdded) {
            // Failed to add product to cart. Display message.
            if (data.customProductAddFailed) {
              this.displaySpectrumWarning(data);
            } else if (data.message) {
              this.displayRichError(data);
            }
          } else {
            // Product successfully added.
            this.cartSuccessMessage = this.bp('addedToCart', data.quantityAdded);
            updateMiniCartCount(data.quantity);

            if (this.b2b) {
              this.fetchMiniCart();
            }
          }
        })
        .catch(() => {
          this.displaySimpleError(this.bp('cartErrorGeneral'));
        })
        .finally(() => {
          this.isAddingToCart = false;
          this.addToCartButtonCaption = this.bp('addToBasket');
        });
    },
  },
  mounted() {
    this.addToCartButtonCaption = this.bp('addToBasket');
  },
  data() {
    return {
      addToCartButtonCaption: '',
      isAddingToCart: false,
      cartSuccessMessage: '',
    };
  },
};

export {AddToCart};
